import { render, staticRenderFns } from "./mo-textarea-wrapper.html?vue&type=template&id=3aa80b6d&external"
import script from "./mo-textarea-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-textarea-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa80b6d')) {
      api.createRecord('3aa80b6d', component.options)
    } else {
      api.reload('3aa80b6d', component.options)
    }
    module.hot.accept("./mo-textarea-wrapper.html?vue&type=template&id=3aa80b6d&external", function () {
      api.rerender('3aa80b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-textarea-wrapper/mo-textarea-wrapper.vue"
export default component.exports